import React from "react";
import styles from "./index.module.scss";

export interface DiceProps {
  // increase: (inc: number) => void;
  rolled?: number;
  isAnnimate?: Boolean;
  stopAnnimation?: () => void;
  top?: Boolean;
}

function Dice({ rolled, isAnnimate, stopAnnimation, top }: DiceProps) {
  return (
    <div
      id="box"
      className={`${styles.box} ${isAnnimate && styles.animateDrop}`}
    >
      <div
        id="cube"
        className={`${styles.cube} 
        ${top && styles.box1} 
        ${top && isAnnimate && styles.animateDrop1} 
        ${isAnnimate && styles.animateCubeRoll}`}
        onAnimationEnd={stopAnnimation}
      >
        <div className={`${styles.side} ${styles.front}`}>{rolled}</div>
        <div className={`${styles.side} ${styles.back}`}>4</div>
        <div className={`${styles.side} ${styles.right}`}></div>
        <div className={`${styles.side} ${styles.left}`}></div>
        <div className={`${styles.side} ${styles.top}`}>3</div>
        <div className={`${styles.side} ${styles.bottom}`}>6</div>
      </div>
    </div>
  );
}

export default Dice;
